// extracted by mini-css-extract-plugin
export default {"container":"layout_container__246h7","header":"layout_header__13rGI","content":"layout_content__0JIq5"};